import Path from "../../../services/paths";
import PreAndPostOpsoActions from "../../prat_actions/preAndPostOpso/preAndPostOpsoActions";
import DownloadXlxActions from "../../actions/downloadXlxActions";
import utils from "../../common/utils";
import axios from "axios";
import CustomToast from '../../../util-functions/customToast.jsx'

class PreAndPostOpsoMiddleware {
    static getPreAndPostOpso(
        selectedProductDivisions,
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus,
        selectedProductFormats,
        selectedYear,
        selectedMonth,
        selectedWeekFrom,
        selectedWeekTo,
        selectedPromotionType,
        selectedGeoRegions,
        selectedMasterChannel,
        selectedChannel,
        selectedElements,
        selectedSubElement
    ) {

        let url = `${Path.GET_PRE_AND_POST_OPSO}?`;
        if (Array.isArray(selectedProductDivisions)) {
            selectedProductDivisions.forEach(element => {
                url += `division=${element}&`;
            });
        }

        if (selectedProductCategories) {
                url += `category=${selectedProductCategories}&`;
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }

        if (Array.isArray(selectedProductFormats)) {
            selectedProductFormats.forEach(element => {
                url += `sku_format=${element}&`;
            });
        }

        if (selectedYear) {
            url += `year=${selectedYear}&`;
        }

        if (Array.isArray(selectedMonth)) {
            selectedMonth.forEach(element => {
                url += `month=${element}&`;
            });
        }

        if (selectedWeekFrom) {
            url += `week_from=${selectedWeekFrom}&`;
        }

        if (selectedWeekTo) {
            url += `week_to=${selectedWeekTo}&`;
        }

        if (selectedPromotionType) {
            url += `promotion_type=${selectedPromotionType}&`;
        }

        if (Array.isArray(selectedGeoRegions)) {
            selectedGeoRegions.forEach(element => {
                url += `region=${element}&`;
            });
        }

        if (Array.isArray(selectedMasterChannel)) {
            selectedMasterChannel.forEach(element => {
                url += `master_channel=${element}&`;
            });
        }

        if (Array.isArray(selectedChannel)) {
            selectedChannel.forEach(element => {
                url += `channel=${element}&`;
            });
        }

        if (Array.isArray(selectedElements)) {
            selectedElements.forEach(element => {
                url += `element=${element}&`;
            });
        }

        if (Array.isArray(selectedSubElement)) {
            selectedSubElement.forEach(element => {
                url += `sub_element=${element}&`;
            });
        }

        


        url = url.slice(0, -1);

        return dispatch => {
            dispatch(PreAndPostOpsoActions.preAndPostOpsoRequest());

            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.status === 404) {
                                dispatch(PreAndPostOpsoActions.preAndPostOpsoFailed());
                            } else {
                                dispatch(PreAndPostOpsoActions.preAndPostOpsoSuccessul(res));
                            }
                        })
                        .catch(error => {
                            dispatch(PreAndPostOpsoActions.preAndPostOpsoFailed());
                        });
                })
                .catch(error => {
                    dispatch(PreAndPostOpsoActions.preAndPostOpsoFailed(error));
                });
        };
    }


    static downloadPreVsPostOpso(
        fileType,
        selectedProductDivisions,
        selectedProductCategories,
        selectedProductBrands,
        selectedProductMasterSkus,
        selectedProductFormats,
        selectedYear,
        selectedMonth,
        selectedWeekFrom,
        selectedWeekTo,
        selectedPromotionType,
        selectedGeoRegions,
        selectedMasterChannel,
        selectedChannel,
        selectedElements,
        selectedSubElement
      ) {
    
        let url = `${fileType===1 ? Path.DOWNLOAD_PRE_POST_OPSO_TOTAL_CUT :Path.DOWNLOAD_PRE_POST_OPSO}?`;
       
        if (Array.isArray(selectedProductDivisions)) {
            selectedProductDivisions.forEach(element => {
                url += `division=${element}&`;
            });
        }

        if (selectedProductCategories) {
            url += `category=${selectedProductCategories}&`;
        }

        if (Array.isArray(selectedProductBrands)) {
            selectedProductBrands.forEach(element => {
                url += `brand=${element}&`;
            });
        }

        if (Array.isArray(selectedProductMasterSkus)) {
            selectedProductMasterSkus.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }

        if (Array.isArray(selectedProductFormats)) {
            selectedProductFormats.forEach(element => {
                url += `sku_format=${element}&`;
            });
        }

        if (selectedYear) {
            url += `year=${selectedYear}&`;
        }

        if (Array.isArray(selectedMonth)) {
            selectedMonth.forEach(element => {
                url += `month=${element}&`;
            });
        }

        if (selectedWeekFrom) {
            url += `week_from=${selectedWeekFrom}&`;
        }

        if (selectedWeekTo) {
            url += `week_to=${selectedWeekTo}&`;
        }

        if (selectedPromotionType) {
            url += `promotion_type=${selectedPromotionType}&`;
        }

        if (Array.isArray(selectedGeoRegions)) {
            selectedGeoRegions.forEach(element => {
                url += `region=${element}&`;
            });
        }

        if (Array.isArray(selectedMasterChannel)) {
            selectedMasterChannel.forEach(element => {
                url += `master_channel=${element}&`;
            });
        }

        if (Array.isArray(selectedChannel)) {
            selectedChannel.forEach(element => {
                url += `channel=${element}&`;
            });
        }

        if (Array.isArray(selectedElements)) {
            selectedElements.forEach(element => {
                url += `element=${element}&`;
            });
        }

        if (Array.isArray(selectedSubElement)) {
            selectedSubElement.forEach(element => {
                url += `sub_element=${element}&`;
            });
        }
    
        url = url.slice(0, -1);
    
    
        return dispatch => {
          dispatch(DownloadXlxActions.downloadXlxRequest());
    
          utils
            .get_token()
            .then(token => {
              axios({
                method: "GET",
                url: url,
                responseType: 'blob',
                headers: {
                  "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                  Authorization: `Bearer ${token}`
                }
              })
                .then(res => {
                  if (res.error) {
                  } else {
                    let fileName = res.headers['content-disposition'].slice(res.headers['content-disposition'].indexOf('=')+1,)
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    // ToastsStore.success("Download Successful")
                    CustomToast('success', 'Download Successful')
                    dispatch(DownloadXlxActions.downloadXlxSuccessul(res));
                  }
                })
                .catch(error => {
                //   ToastsStore.error("Download Failed!");
                CustomToast('error', 'Download Failed!')
                  dispatch(DownloadXlxActions.downloadXlxFailed(error));
                });
            })
            .catch(error => {
              dispatch(DownloadXlxActions.downloadXlxFailed(error));
            });
        };
      }
}

export default PreAndPostOpsoMiddleware;
